import axios from "axios";
import { toast } from "sonner";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true, timeout: 30000 });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ag_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const notifyNetworkError = () => {
  toast.error("Impossible de contacter le serveur. Veuillez réessayer.", {
    id: "network-error",
    duration: 6000,
    action: { label: "Réessayer", onClick: () => window.location.reload() },
  });
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    if (!err.response || status >= 502) {
      if (!window.location.pathname.startsWith("/login")) notifyNetworkError();
    } else if (status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("ag_token");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;

export const fmtErr = (e) => {
  const status = e?.response?.status;
  if (!e?.response || status >= 502) return "Impossible de contacter le serveur. Veuillez réessayer.";
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erreur inconnue";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

export const openPdf = async (path) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  window.open(url, "_blank");
};

export const downloadExcel = async (path) => {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = path.split("?")[0].split("/").pop() + ".xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
